import { accessTokenInterceptor } from '@teko/auth';
import Api from '@teko/api';
import { getError } from './error.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizeData = (responseAddresses) => {
  return responseAddresses.map((addr) => __spreadProps(__spreadValues({}, addr), { addressId: addr.id }));
};
class UserService {
  constructor(userServiceUrl, platformCode, platformId, getCustomAccessToken) {
    this.myProfile = async (params = {}) => {
      var _a;
      const { data } = await this.userApi.get("/profiles", {
        params: this.getParams(params)
      });
      return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.profile;
    };
    this.updateProfile = async (body) => {
      var _a;
      const { data } = await this.userApi.patch("/profiles", body, {
        params: this.getParams({})
      });
      return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.profile;
    };
    this.getClient = async () => {
      var _a;
      const { data } = await this.userApi.get(`/clients?platformIds=${this.platformId}`);
      return (_a = data.result) == null ? void 0 : _a.clients;
    };
    this.updateBillings = async (body) => {
      const { data } = await this.userApi.post("/billings", body, {
        params: this.getParams({})
      });
      return data;
    };
    this.getMyAddresses = async () => {
      const {
        data: {
          result: { addresses }
        }
      } = await this.userApi.get("/addresses", {
        params: this.getParams({})
      });
      return normalizeData(addresses);
    };
    this.createAddress = async (address) => {
      const {
        data: {
          result: { address: addressResp }
        }
      } = await this.userApi.post("/addresses", __spreadProps(__spreadValues({}, address), {
        platformId: this.platformId
      }));
      return addressResp;
    };
    this.updateAddress = async (addressId, address) => {
      await this.userApi.patch(`/addresses/${addressId}`, __spreadProps(__spreadValues({}, address), {
        platformId: this.platformId
      }));
    };
    this.getAddress = async (addressId) => {
      const {
        data: {
          result: { address }
        }
      } = await this.userApi.get(`/addresses/${addressId}`);
      return address;
    };
    this.deleteAddress = async (addressId) => {
      const { data } = await this.userApi.delete(`/addresses/${addressId}`);
      return data;
    };
    this.viewPoint = async () => {
      return await this.userApi.get("/loyalty/viewpoint", {
        params: this.getParams({})
      });
    };
    this.registerLoyaltyMember = async (data) => {
      return await this.userApi.post("/loyalty/members", data, {
        params: this.getParams({})
      });
    };
    this.getRefCodeInfo = async (refCode) => {
      return this.userApi.get(`/dealer_farmer/ref/${refCode}`).then((res) => res.data);
    };
    this.confirmFarmer = async (refCode) => {
      return this.userApi.post("/dealer_farmer/confirm", {
        referenceCode: refCode
      });
    };
    this.upsertProfile = async (profileUpsertObject) => {
      const { data } = await this.userApi.post("/profiles/upsert", profileUpsertObject, {
        params: this.getParams({})
      });
      return data == null ? void 0 : data.data;
    };
    this.searchProfile = async (params = {}) => {
      const { data } = await this.userApi.get("/profiles/search", {
        params: this.getParams(params)
      });
      return data == null ? void 0 : data.data;
    };
    this.customerTypes = async (params = {}) => {
      const { data } = await this.userApi.get("/customer-types", {
        params: this.getParams(params)
      });
      return data;
    };
    this.getProfileDetail = async (profileId) => {
      const { data } = await this.userApi.get(`/profiles/${profileId}`, {
        params: this.getParams({})
      });
      return data == null ? void 0 : data.data;
    };
    this.userApi = new Api(userServiceUrl, getError);
    this.platformCode = platformCode;
    this.platformId = platformId;
    if (typeof getCustomAccessToken === "function") {
      this.userApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.userApi.addInterceptor(accessTokenInterceptor);
    }
  }
  getParams(params) {
    return __spreadValues(__spreadValues(__spreadValues({}, !!this.platformCode ? { platformCode: this.platformCode } : {}), !!this.platformId ? { platformId: this.platformId } : {}), params);
  }
}

export { UserService };
